const IndexPage = () => {
  return (
    <>
      <div>Analysis Index Screen</div>
    </>
  )
}

export default IndexPage
